/**
 * @file brands.tsx
 * @deprecated Copied to app/modules/procurement/pages/master/brands/brands.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/master/brands
 * @description Page component for managing brands in the master section.
 *   Displays a list of brands with pagination, search functionality, and CRUD operations.
 *   Allows users to view, edit, and delete brands with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Warehouse refetch: fetchBrands runs on mount only; refetch when selectedWarehouse changes
 *   so list/delete reflect the active warehouse context.
 * @todo Duplicate page titles: uProcure/master/index.tsx uses PageTitle on routes; this component
 *   also renders h1 — remove one.
 * @todo Route-level permission guard: component uses history.back() on mount only; add Brand
 *   permission check in PrivateRoutes or route wrapper if required.
 * @todo brandsJSON gap: apiJSON/master.ts addBrands/editBrands lack auditLogMessage support and
 *   editBrands does not append isTobacco (edit-brand UI collects it but payload drops it).
 * @todo Cleanup: remove unused stock1 import; remove commented duplicate KTSVG import.
 */

import { useState, useEffect } from "react";
import { Row, Col, Card, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../../../../Global/loader";
import Pagination from "../../../../../Global/pagination";
// import DropDownMenu1 from "./dropdown/DropDownMenu1";
import ThreeDotMenu from "../../../../../_admin/assets/media/svg_uTrade/three-dot.svg";
import stock1 from "../../../../_admin/assets/media/product/i1.webp";
import { CustomSelectTable } from "../../../../custom/Select/CustomSelectTable";
import APICallService from "../../../../../api/apiCallService";
import { master } from "../../../../../api/apiEndPoints";
import { KTSVG } from "../../../../../_admin/helpers";
import { brandsJSON } from "../../../../../api/apiJSON/master";
import {
  Add,
  Brand,
  Delete,
  Edit,
  PAGE_LIMIT,
} from "../../../../../utils/constants";
import { getKey, setKey } from "../../../../../Global/history";
import { listBrands } from "../../../../../utils/storeString";
// import { KTSVG } from '../../../../_admin/helpers';
import DeleteModal from "../../../../modals/delete";
import { masterToast } from "../../../../../utils/toast";
import { success } from "../../../../../Global/toast";
import { ElementAnimateUtil } from "../../../../../_admin/assets/ts/_utils";
import { useAuth } from "../../../auth";
import Method from "../../../../../utils/methods";
// import { warehouse as warehouseStoreString } from '../../../../utils/storeString';
import { useWarehouse } from "../../../../context/WarehouseContext";
const Brands = () => {
  const { selectedWarehouse } = useWarehouse();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);

  const [brands, setBrands] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState<any>();
  const [deleteLoader, setDeleteLoader] = useState(false);

  const [show, setShow] = useState(false);
  const [id, setId] = useState(-1);
  const [page, setPage] = useState<any>(getKey(listBrands.page) || 1);
  const [search, setSearch] = useState<string>("");
  const [pageLimit, setPageLimit] = useState<any>(
    getKey(listBrands.limit) || PAGE_LIMIT,
  );
  const [fetchLoader, setFetchLoader] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      if (!Method.hasModulePermission(Brand, currentUser)) {
        return window.history.back();
      }
      setLoading(true);
      await fetchBrands(page, pageLimit);
      setDataFetched(true);
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (dataFetched) {
      let initialScrollPosition: any = getKey(listBrands.scrollPosition);
      if (initialScrollPosition) {
        ElementAnimateUtil.scrollTo(parseInt(initialScrollPosition));
        setDataFetched(false);
      }
    }
  }, [dataFetched]);

  const fetchBrands = async (
    pageNo: number,
    limit: number,
    searchTerm?: String,
  ) => {
    setLoading(true);
    let params: any = {
      pageNo: pageNo,
      limit: limit,
      sortKey: "title",
      sortOrder: 1,
      searchTerm: searchTerm,
    };
    if (selectedWarehouse?.value) {
      params.warehouse = selectedWarehouse?.value;
    }
    let apiService = new APICallService(
      master.listBrands,
      brandsJSON.listBrands(params),
      "",
      "",
      "",
      "",
      Brand,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.records) {
      if (response.total) {
        setTotalRecords(response.total);
      }
      setBrands(response.records);
    }
    setLoading(false);
  };
  const openMenuOnClick = async (index: any) => {
    setId(index);
    setShow(true);
  };
  const onMenuClose = async () => {
    setId(-1);
    setShow(false);
  };
  const onMenuOpen = async (index: any) => {
    setId(index);
    setShow(true);
  };
  const handleOption = async (event: any, index: number, data: any) => {
    let currentScrollY = window.scrollY;
    setKey(listBrands.scrollPosition, currentScrollY);
    if (event.value === 1) {
      navigate("/UProcure/master/brands/edit-brand", { state: data });
    } else if (event.value === 2) {
      setDeleteModalOpen(true);
      setSelectedBrand(data);
    } else if (event.value === 0) {
    }
  };
  const handleCurrentPage = async (val: number) => {
    setPage(val);
    setKey(listBrands.page, val);
    await fetchBrands(val, pageLimit, search);
  };
  const handleNextPage = async (val: number) => {
    setPage(val + 1);
    setKey(listBrands.page, val + 1);
    await fetchBrands(val + 1, pageLimit, search);
  };
  const handlePreviousPage = async (val: number) => {
    setPage(val - 1);
    setKey(listBrands.page, val - 1);
    await fetchBrands(val - 1, pageLimit, search);
  };
  const handlePageLimit = async (event: any) => {
    setPage(1);
    setPageLimit(event.target.value);
    setKey(listBrands.page, 1);
    setKey(listBrands.limit, parseInt(event.target.value));
    await fetchBrands(1, event.target.value, search);
  };
  const handleSearch = async (value: string) => {
    setSearch(value);
    setPage(1);
    setKey(listBrands.page, 1);
    await fetchBrands(1, pageLimit, value);
  };

  const handleDelete = async () => {
    setDeleteLoader(true);
    let apiService = new APICallService(
      master.deleteBrands,
      selectedBrand?._id,
      "",
      "",
      "",
      true,
      Brand,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.error) {
      setError(response.error);
    } else {
      setPage(1);
      setKey(listBrands.page, 1);
      fetchBrands(1, pageLimit);
      success(masterToast.deletebrand);
      setDeleteModalOpen(false);
    }
    setDeleteLoader(false);
  };

  const handleModalHide = () => {
    setDeleteModalOpen(false);
    setError("");
  };

  return (
    <>
      {deleteModalOpen && (
        <DeleteModal
          show={deleteModalOpen}
          onHide={handleModalHide}
          service={selectedBrand}
          handleDelete={handleDelete}
          error={error}
          loading={deleteLoader}
          serviceName="brand"
          message={`Are you sure you want to delete ${selectedBrand.title} brand?`}
          warnMessage={`By continuing, the ${selectedBrand.title} brand will
          be removed permanently`}
        />
      )}
      <div className="p-5">
        <Row className="align-items-center">
          <Col md className="align-self-center mb-5">
            <h1 className="fs-22 fw-bolder mb-0">Brands</h1>
          </Col>
          <Col className="d-flex  align-items-center justify-content-end">
            <Col className="d-flex justify-content-end align-items-center">
              <div className="d-flex align-items-center position-relative me-lg-4">
                <KTSVG
                  path="/media/icons/duotune/general/gen021.svg"
                  className="svg-icon-3 position-absolute ms-3"
                />
                <input
                  type="text"
                  id="kt_filter_search"
                  className="form-control form-control-white form-control-lg ps-10 w-350px"
                  placeholder="Search"
                  onChange={(event: any) => {
                    handleSearch(event.target.value.trimStart());
                  }}
                  value={search}
                />
              </div>
            </Col>
            <Col md={"auto"} className="text-right mb-5 mt-4">
              {Method.hasPermission(Brand, Add, currentUser) ? (
                <Link
                  to="/UProcure/master/brands/add-brand"
                  className="uw-btn uw-btn-primary uw-btn-lg btn btn-primary mh-md-50px btn-lg fs-16 fw-600"
                >
                  Add
                </Link>
              ) : (
                <></>
              )}
            </Col>
          </Col>
          <Col lg={12}>
            {loading ? (
              // <div className="d-flex justify-content-center m-4 h-200px">
              //   <Loader loading={loading} />
              // </div>
              <Card className="border border-r10px">
                <Card.Body className="pt-1 py-3 px-8 mb-3">
                  <div className="table-responsive">
                    <table className="table table-rounded table-row-bordered align-middle gy-3 mb-0 ">
                      <thead>
                        <tr className="fw-bold fs-16 fw-600 text-dark border-bottom h-60px align-middle">
                          <th className="px-0 min-w-md-300px">All Brands</th>
                          <th className="px-0 min-w-50px">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {brands.length ? (
                          brands.map((brandVal: any, index: number) => {
                            return (
                              <tr>
                                <td>
                                  <div className="d-inline-flex align-items-center">
                                    <div className="symbol symbol-40px border border-r10px me-4">
                                      <img
                                        className="img-fluid border-r10px object-fit-contain align-self-center"
                                        src={brandVal.image}
                                        alt=""
                                        // onClick={() => handleImage(certVal.image)}
                                      />
                                    </div>
                                    <span className="fs-15 fw-500">
                                      {brandVal.title}
                                    </span>
                                  </div>
                                </td>
                                <td className="text-end">
                                  {Method.hasPermission(
                                    Brand,
                                    Edit,
                                    currentUser,
                                  ) ||
                                  Method.hasPermission(
                                    Brand,
                                    Delete,
                                    currentUser,
                                  ) ? (
                                    <CustomSelectTable
                                      marginLeft={"0px"}
                                      width={"auto"}
                                      placeholder={
                                        <img
                                          className="img-fluid"
                                          width={23}
                                          height={6}
                                          src={ThreeDotMenu}
                                          alt=""
                                        />
                                      }
                                      options={[
                                        ...(Method.hasPermission(
                                          Brand,
                                          Edit,
                                          currentUser,
                                        )
                                          ? [
                                              {
                                                label: (
                                                  <button className="btn btn-link fs-14 fw-500 text-black ms-3 p-4">
                                                    Edit
                                                  </button>
                                                ),
                                                value: 1,
                                              },
                                            ]
                                          : []),
                                        ...(Method.hasPermission(
                                          Brand,
                                          Delete,
                                          currentUser,
                                        )
                                          ? [
                                              {
                                                label: (
                                                  <button className="btn btn-link fs-14 fw-500 text-danger ms-3 p-4">
                                                    Delete
                                                  </button>
                                                ),
                                                value: 2,
                                              },
                                            ]
                                          : []),
                                      ]}
                                      backgroundColor="white"
                                      show={show && index === id}
                                      onMenuClose={() => {
                                        onMenuClose();
                                      }}
                                      openMenuOnClick={() => {
                                        openMenuOnClick(index);
                                      }}
                                      onMenuOpen={() => {
                                        onMenuOpen(index);
                                      }}
                                      onChange={(event: any) => {
                                        handleOption(event, index, brandVal);
                                      }}
                                      isOptionDisabled={(option: any) =>
                                        option.value === 3
                                      }
                                    />
                                  ) : (
                                    <></>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <>
                            {" "}
                            <tr>
                              <td colSpan={2}>
                                <div className="d-flex justify-content-center">
                                  <Loader loading={loading} />
                                </div>
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </Card.Body>
              </Card>
            ) : (
              <>
                {brands.length > 0 ? (
                  <>
                    <Card className="border border-r10px">
                      <Card.Body className="pt-1 py-3 px-8 mb-3">
                        <div className="table-responsive">
                          <table className="table table-rounded table-row-bordered align-middle gy-3 mb-0 ">
                            <thead>
                              <tr className="fw-bold fs-16 fw-600 text-dark border-bottom h-60px align-middle">
                                <th className="px-0 min-w-md-300px">All Brands</th>
                                <th className="px-0 min-w-50px">&nbsp;</th>
                              </tr>
                            </thead>
                            <tbody>
                              {brands.map((brandVal: any, index: number) => {
                                return (
                                  <tr>
                                    <td>
                                      <div className="d-inline-flex align-items-center">
                                        <div className="symbol symbol-40px border border-r10px me-4">
                                          <img
                                            className="img-fluid border-r10px object-fit-contain align-self-center"
                                            src={brandVal.image}
                                            alt=""
                                            // onClick={() => handleImage(certVal.image)}
                                          />
                                        </div>
                                        <span className="fs-15 fw-500">
                                          {brandVal.title}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="text-end">
                                      {Method.hasPermission(
                                        Brand,
                                        Edit,
                                        currentUser,
                                      ) ||
                                      Method.hasPermission(
                                        Brand,
                                        Delete,
                                        currentUser,
                                      ) ? (
                                        <CustomSelectTable
                                          marginLeft={"0px"}
                                          width={"auto"}
                                          placeholder={
                                            <img
                                              className="img-fluid"
                                              width={23}
                                              height={6}
                                              src={ThreeDotMenu}
                                              alt=""
                                            />
                                          }
                                          options={[
                                            ...(Method.hasPermission(
                                              Brand,
                                              Edit,
                                              currentUser,
                                            )
                                              ? [
                                                  {
                                                    label: (
                                                      <button className="btn btn-link fs-14 fw-500 text-black ms-3 p-4">
                                                        Edit
                                                      </button>
                                                    ),
                                                    value: 1,
                                                  },
                                                ]
                                              : []),
                                            ...(Method.hasPermission(
                                              Brand,
                                              Delete,
                                              currentUser,
                                            )
                                              ? [
                                                  {
                                                    label: (
                                                      <button className="btn btn-link fs-14 fw-500 text-danger ms-3 p-4">
                                                        Delete
                                                      </button>
                                                    ),
                                                    value: 2,
                                                  },
                                                ]
                                              : []),
                                          ]}
                                          backgroundColor="white"
                                          show={show && index === id}
                                          onMenuClose={() => {
                                            onMenuClose();
                                          }}
                                          openMenuOnClick={() => {
                                            openMenuOnClick(index);
                                          }}
                                          onMenuOpen={() => {
                                            onMenuOpen(index);
                                          }}
                                          onChange={(event: any) => {
                                            handleOption(
                                              event,
                                              index,
                                              brandVal,
                                            );
                                          }}
                                          isOptionDisabled={(option: any) =>
                                            option.value === 3
                                          }
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </Card.Body>
                    </Card>
                    {!loading ? (
                      <Pagination
                        totalRecords={totalRecords}
                        currentPage={page}
                        handleCurrentPage={handleCurrentPage}
                        handleNextPage={handleNextPage}
                        handlePreviousPage={handlePreviousPage}
                        handlePageLimit={handlePageLimit}
                        pageLimit={pageLimit}
                      />
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    <Card className="border border-r10px">
                      <Card.Body className="pt-1 py-3 px-8 mb-3">
                        <div className="table-responsive">
                          <table className="table table-rounded table-row-bordered align-middle gy-3 mb-0 ">
                            <thead>
                              <tr className="fw-bold fs-16 fw-600 text-dark border-bottom h-60px align-middle">
                                <th className="px-0 min-w-md-300px">All Brands</th>
                                <th className="px-0 min-w-50px">&nbsp;</th>
                              </tr>
                            </thead>
                            <tbody>
                              {brands.length ? (
                                brands.map((brandVal: any, index: number) => {
                                  return (
                                    <tr>
                                      <td>
                                        <div className="d-inline-flex align-items-center">
                                          <div className="symbol symbol-40px border border-r10px me-4">
                                            <img
                                              className="img-fluid border-r10px object-fit-contain align-self-center"
                                              src={brandVal.image}
                                              alt=""
                                              // onClick={() => handleImage(certVal.image)}
                                            />
                                          </div>
                                          <span className="fs-15 fw-500">
                                            {brandVal.title}
                                          </span>
                                        </div>
                                      </td>
                                      <td className="text-end">
                                        {Method.hasPermission(
                                          Brand,
                                          Edit,
                                          currentUser,
                                        ) ||
                                        Method.hasPermission(
                                          Brand,
                                          Delete,
                                          currentUser,
                                        ) ? (
                                          <CustomSelectTable
                                            marginLeft={"0px"}
                                            width={"auto"}
                                            placeholder={
                                              <img
                                                className="img-fluid"
                                                width={23}
                                                height={6}
                                                src={ThreeDotMenu}
                                                alt=""
                                              />
                                            }
                                            options={[
                                              ...(Method.hasPermission(
                                                Brand,
                                                Edit,
                                                currentUser,
                                              )
                                                ? [
                                                    {
                                                      label: (
                                                        <button className="btn btn-link fs-14 fw-500 text-black ms-3 p-4">
                                                          Edit details
                                                        </button>
                                                      ),
                                                      value: 1,
                                                    },
                                                  ]
                                                : []),
                                              ...(Method.hasPermission(
                                                Brand,
                                                Delete,
                                                currentUser,
                                              )
                                                ? [
                                                    {
                                                      label: (
                                                        <button className="btn btn-link fs-14 fw-500 text-danger ms-3 p-4">
                                                          Delete details
                                                        </button>
                                                      ),
                                                      value: 2,
                                                    },
                                                  ]
                                                : []),
                                            ]}
                                            backgroundColor="white"
                                            show={show && index === id}
                                            onMenuClose={() => {
                                              onMenuClose();
                                            }}
                                            openMenuOnClick={() => {
                                              openMenuOnClick(index);
                                            }}
                                            onMenuOpen={() => {
                                              onMenuOpen(index);
                                            }}
                                            onChange={(event: any) => {
                                              handleOption(
                                                event,
                                                index,
                                                brandVal,
                                              );
                                            }}
                                            isOptionDisabled={(option: any) =>
                                              option.value === 3
                                            }
                                          />
                                        ) : (
                                          <></>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <>
                                  {" "}
                                  <tr>
                                    <td colSpan={2}>
                                      <div className="d-flex justify-content-center">
                                        <span className="fs-15 fw-500">
                                          No Data found
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </Card.Body>
                    </Card>
                  </>
                )}
              </>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};
export default Brands;
